// AUTO-GENERATED FILE. Do not edit.
export interface BuildInfo {
  version: string;
  build: string;
  commit: string;
  branch: string;
  date: string;
  environment: string;
  /** Version lisible pour les utilisateurs, ex: "v2.1.0 #42" */
  displayVersion: string;
  /** Version technique complète, ex: "2.1.0+42.a3f8b2c" */
  fullVersion: string;
}

export const BUILD_INFO: BuildInfo = {
  "version": "2.1.57",
  "build": "180",
  "commit": "5aa4c33",
  "branch": "main",
  "date": "2026-11-05T09:20:45.880Z",
  "environment": "production",
  "displayVersion": "v2.1.57 #180",
  "fullVersion": "2.1.57+180.5aa4c33"
} as const;
